import _, { mapKeys, camelCase } from "lodash";
import * as convert from "xml-js";

export class ApiAdapter {
  public baseURL: string;
  public token: string;
  public HTTPPostHeader: {};

  constructor() {
    this.token = $('meta[name="csrf-token"]').attr("content");
    this.HTTPPostHeader = {
      Accept: "application/json, text/javascript, */*; q=0.01",
      "Content-type": "application/json",
      "X-PREVENT-BASIC-AUTH": "true",
      "X-CSRF-Token": this.token,
      "X-Requested-With": "XMLHttpRequest",
    };
  }


  loadAltContacts() {
    var patientId: number = $j("#patient").val();
    this.baseURL = `contacts/${patientId}`;

    return fetch(this.baseURL)
    .then((response) => {
      return response.text()

    })
    .then((data) => {
      var options = { compact: true, ignoreComment: true, spaces: 0 };

      var datajson = convert.xml2js(data, options);
      var contacts = datajson["contacts"]["contact"];

      if(!Array.isArray(contacts)){
        contacts = [contacts].filter(function(el) { return el; })
      }

      var select_options = [];
      contacts.forEach(function (item) {
        var id = item["id"]._text;
        var full_name = item["full-name"]._text;
        select_options.push({ value: id, label: full_name })
      })

        return select_options;
      });
  }


  loadProviders() {
    var patientId: number = $j("#patient").val();
    this.baseURL = `providers/${patientId}`;
    var options = { compact: true, ignoreComment: true, spaces: 0 };

    return fetch(this.baseURL)
      .then((response) => {
        return response.text()

      })
      .then((data) => {

        var datajson = convert.xml2js(data, options);
        var providers = datajson["providers"]["provider"];
        
        if(!Array.isArray(providers)){
          providers = [providers].filter(function(el) { return el; })
        }

        var select_options = [];
        providers.forEach(function (item) {
          var id = item["id"]._text;
          var full_name = item["full-name"]._text;
          
          select_options.push({ value: id, label: full_name })
        })

        return select_options;
      });
  }

  loadHost() {
    var patientId: number = $j("#patient").val();
    this.baseURL = `hosts/${patientId}`;
    var options = { compact: true, ignoreComment: true, spaces: 0 };

    return fetch(this.baseURL)
      .then((response) => {
        return response.text()

      })
      .then((data) => {

        var datajson = convert.xml2js(data, options);
        var providers = datajson["providers"]["provider"];

        if(!Array.isArray(providers)){
          providers = [providers].filter(function(el) { return el; })
        }

        var select_options = [];
        providers.forEach(function (item) {
          var id = item["id"]._text;
          var full_name = item["full-name"]._text;          

          select_options.push({ value: id, label: full_name })
        })

        return select_options;
      });
  }


}
